/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useMemo } from 'react';
import { createContext, PropsWithChildren, useEffect, useState } from 'react';
import { IPhoneWidgetProps } from '../../components/phone-widget';

export interface IPhoneWidgetPropsContext {
  widgetProps: IPhoneWidgetProps | undefined;
  setWidgetProps(props: IPhoneWidgetProps): void;
}

export const PhoneWidgetPropsContext = createContext<IPhoneWidgetPropsContext>(null!);

export default function PhoneWidgetPropsProvider(props: PropsWithChildren<any>) {
  const [widgetProps, setWidgetProps] = useState<IPhoneWidgetProps>();

  const contextValue = useMemo(() => ({ widgetProps, setWidgetProps }), [widgetProps]);

  return <PhoneWidgetPropsContext.Provider value={contextValue}>{props.children}</PhoneWidgetPropsContext.Provider>;
}
